module.exports = __webpack_public_path__ + "img/2015,-The-Fortunate-Isles,-Acrylic-,-gouache-and-acrylic-ink-on-cotton-paper,-200-x-130cm.fe31f500.jpg";